import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const getStatusColor = (status, theme) => {
    const lowerStatus = status?.toLowerCase();
    
    if (['active', 'unblock', 'approved', 'verified'].includes(lowerStatus)) {
        return theme.palette.mode === 'dark' 
            ? { bg: 'rgba(34, 197, 94, 0.15)', text: '#4ade80', border: 'rgba(34, 197, 94, 0.3)' } 
            : { bg: 'rgba(34, 197, 94, 0.1)', text: '#16a34a', border: 'rgba(34, 197, 94, 0.2)' };
    }
    if (['blocked', 'block', 'rejected', 'inactive'].includes(lowerStatus)) {
        return theme.palette.mode === 'dark'
            ? { bg: 'rgba(239, 68, 68, 0.15)', text: '#f87171', border: 'rgba(239, 68, 68, 0.3)' }
            : { bg: 'rgba(239, 68, 68, 0.1)', text: '#dc2626', border: 'rgba(239, 68, 68, 0.2)' };
    }
    if (['pending'].includes(lowerStatus)) {
        return theme.palette.mode === 'dark'
            ? { bg: 'rgba(234, 179, 8, 0.15)', text: '#facc15', border: 'rgba(234, 179, 8, 0.3)' }
            : { bg: 'rgba(234, 179, 8, 0.1)', text: '#ca8a04', border: 'rgba(234, 179, 8, 0.2)' };
    }
    // Default / Info
    return theme.palette.mode === 'dark'
        ? { bg: 'rgba(6, 182, 212, 0.15)', text: '#22d3ee', border: 'rgba(6, 182, 212, 0.3)' }
        : { bg: 'rgba(6, 182, 212, 0.1)', text: '#0891b2', border: 'rgba(6, 182, 212, 0.2)' };
};

const StatusChip = ({ status, label }) => {
    const theme = useTheme();
    const colors = getStatusColor(status || label, theme);

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4px 12px',
                borderRadius: '50px',
                backgroundColor: colors.bg,
                border: `1px solid ${colors.border}`,
                minWidth: '80px',
                transition: 'all 0.3s ease',
                '&:hover': {
                    boxShadow: `0 0 10px ${colors.bg}`,
                }
            }}
        >
            <Typography
                sx={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: colors.text,
                    textTransform: 'capitalize',
                    letterSpacing: '0.5px'
                }}
            >
                {label || status}
            </Typography>
        </Box>
    );
};

export default StatusChip;
